import { pipe } from "fp";

export type English = string;

export namespace English {
  export const list = (...literals: readonly Literal[]): string | undefined =>
    pipe(literals.map(Literal.toString), ([first, second, ...rest]) =>
      !first
        ? undefined
        : first && !second
        ? first
        : first && second && !rest[0]
        ? `${first} and ${second}`
        : pipe(
            {
              middles: rest.slice(0, -1),
              last: rest.slice(-1)[0],
            },
            ({ middles, last }) => ({
              first: Literal.toString(first),
              second: Literal.toString(second),
              middles: middles.map(Literal.toString),
              last: Literal.toString(last),
            }),
            ({ first, second, middles, last }) =>
              `${[first, second, ...middles].join(", ")}, and ${last}`
          )
    );

  export const pluralize = (singular: string, plural?: string) => (
    count: number
  ): string => `${count} ${count > 1 ? plural ?? `${singular}s` : singular}`;

  export type Literal = string | number;
  export namespace Literal {
    export const toString = (literal: Literal): string => `${literal}`;
  }
}
